<script>
    import {
        CardLayout,
        PasswordInput,
    } from "../../../Components/Common/index.svelte";

    import {
        getEmailValidation,
        getMobileValidation,
    } from "../../../Utils/utilFunctions.svelte";

    export let userDetails = {};

    $: isValidEmail = getEmailValidation(userDetails.email);

    $: isValidPhone = getMobileValidation(userDetails.phone);

    let errInputs = [];

    export const checkUserValidation = () => {
        errInputs = [];

        _updateInvalidFieldsStyle();

        return errInputs.length == 0;
    };

    // HELPER FUNCTIONS
    const _updateInvalidFieldsStyle = () => {
        if (!userDetails.email || !isValidEmail) {
            _setErrorStyle("userEmailInput");
            userDetails.verifiedEmail = false;
        } else {
            _resetDefaultStyle("userEmailInput");
            userDetails.verifiedEmail = true;
        }

        if (!userDetails.fullName) _setErrorStyle("userfullNameInput");
        else _resetDefaultStyle("userfullNameInput");

        if (!isValidPhone) {
            _setErrorStyle("userPhoneInput");
            userDetails.verifiedPhone = false;
        } else {
            _resetDefaultStyle("userPhoneInput");
            userDetails.verifiedPhone = true;
        }

        if (errInputs.length) {
            const scrollToElement = document.getElementById(errInputs[0]);
            if (scrollToElement)
                scrollToElement.scrollIntoView({ behavior: "smooth" });
        }
    };

    const _setErrorStyle = (id) => {
        errInputs.push(id);
        const field = document.getElementById(`${id}`);
        field.style.outline = "red solid 2px";
    };

    const _resetDefaultStyle = (id) => {
        const field = document.getElementById(`${id}`);
        field.style.outline = "none";
    };
</script>

<CardLayout title="User Details">
    <div class="flex flex-1 gap-x-4 p-4">
        <div class="flex flex-col flex-1 gap-y-4">
            <div class="flex items-start gap-x-4">
                <p class="title mandatory">Email Address</p>
                <div class="flex flex-col flex-1 gap-y-2">
                    <input
                        type="text"
                        class="input input-sm input-bordered"
                        id="userEmailInput"
                        autocomplete="off"
                        bind:value={userDetails.email}
                        on:focus={() => _resetDefaultStyle("userEmailInput")}
                    />
                    {#if userDetails.email && !isValidEmail}
                        <p class="text-error">Invalid Email Address</p>
                    {/if}
                </div>
            </div>

            <div class="flex items-start gap-x-4">
                <p class="title mandatory">Password</p>
                <PasswordInput bind:value={userDetails.password} isRequired />
            </div>

            <div class="flex items-start gap-x-4">
                <p class="title mandatory">Confirm Password</p>
                <div class="flex flex-col flex-1 gap-y-2">
                    <PasswordInput
                        bind:value={userDetails.confirmPassword}
                        pwdValue={userDetails.password}
                        isConfirm
                        isRequired
                    />
                </div>
            </div>
        </div>

        <div class="divider divider-horizontal" />

        <div class="flex flex-col flex-1 gap-y-4">
            <div class="flex items-center gap-x-4">
                <p class="title mandatory">Full Name</p>
                <input
                    type="text"
                    class="input input-sm input-bordered flex-1"
                    id="userfullNameInput"
                    autocomplete="off"
                    bind:value={userDetails.fullName}
                    on:click={() => _resetDefaultStyle("userfullNameInput")}
                />
            </div>

            <div class="flex items-start gap-x-4">
                <p class="title mandatory">Phone No.</p>
                <div class="flex flex-col flex-1 gap-y-2">
                    <input
                        type="text"
                        class="input input-sm input-bordered"
                        id="userPhoneInput"
                        autocomplete="off"
                        bind:value={userDetails.phone}
                        on:focus={() => _resetDefaultStyle("userPhoneInput")}
                    />
                    {#if userDetails.phone && !isValidPhone}
                        <p class="text-error">Invalid phone number</p>
                    {/if}
                </div>
            </div>

            <div class="flex items-center gap-x-4">
                <p class="title">MFA type</p>
                <select
                    class="select select-sm select-bordered flex-1"
                    bind:value={userDetails.mfa}
                >
                    <option value={Number(0)} selected>None</option>
                    <option value={Number(2)}>SMS</option>
                </select>
            </div>
        </div>
    </div>
</CardLayout>

<style>
    .mandatory::after {
        content: " * ";
    }

    .title {
        line-height: 1.5rem;
        font-size: 1rem;
        font-weight: 700;
        min-width: 10rem;
    }
</style>
